import { Typography } from '@material-ui/core';
import Breadcrumb from '../Breadcrumb';
import SetUpProjectWorkflow1 from './../../assets/SetUpProjectWorkflow-1.png';
import SetUpProjectWorkflow2 from './../../assets/SetUpProjectWorkflow-2.png';
import SetUpProjectWorkflow3 from './../../assets/SetUpProjectWorkflow-3.png';
import SetUpProjectWorkflow4 from './../../assets/SetUpProjectWorkflow-4.png';
import HelpFooter from './HelpFooter';
import useStyles from './useStyles';
import { useTranslation } from 'react-i18next';

export default function SetupProjectWorkflow() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb
        name="topicName"
        data={{
          helpTopic: t('help.topics.projects.label'),
          helpTopicId: 'projects',
          topicName: t('help.subtopics.setupProjectWorkflow'),
          topicNameId: 'setup-project-workflow'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('help.pages.setupProjectWorkflow.title')}
      </Typography>
      <Typography variant="body1">{t('help.pages.setupProjectWorkflow.step1')}</Typography>
      <img
        className={classes.media}
        src={SetUpProjectWorkflow1}
        alt={`${String(t('help.stepAltPrefix'))}1`}
      />
      <Typography variant="body1">{t('help.pages.setupProjectWorkflow.step2')}</Typography>
      <img
        className={classes.media}
        src={SetUpProjectWorkflow2}
        alt={`${String(t('help.stepAltPrefix'))}2`}
      />
      <Typography variant="body1">{t('help.pages.setupProjectWorkflow.step3')}</Typography>
      <img
        className={classes.media}
        src={SetUpProjectWorkflow3}
        alt={`${String(t('help.stepAltPrefix'))}3`}
      />
      <Typography variant="body1">{t('help.pages.setupProjectWorkflow.step4')}</Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.setupProjectWorkflow.templateIntro')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.setupProjectWorkflow.series')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.setupProjectWorkflow.parallel')}
      </Typography>
      <Typography className={classes.textLeftMargin} variant="body2">
        {t('help.pages.setupProjectWorkflow.external')}
      </Typography>
      <img
        className={classes.media}
        src={SetUpProjectWorkflow4}
        alt={`${String(t('help.stepAltPrefix'))}4`}
      />
      <Typography variant="body1">{t('help.pages.setupProjectWorkflow.step5')}</Typography>
      <HelpFooter />
    </div>
  );
}
